(function (Drupal, once) {
  'use strict';

  // Create or extend shared namespace
  window.McmnExperience = window.McmnExperience || {};
  const Mcmn = window.McmnExperience;

  /**
   * Initialize star blinking animation
   */
  function initStarBlinking(starsGroup) {
    const starElements = starsGroup.querySelectorAll('path');
    
    if (starElements.length === 0) {
      return;
    }

    starElements.forEach((star, index) => {
      // Set initial opacity
      gsap.set(star, { opacity: 1 });

      // Create random blinking animation for each star
      const minOpacity = 0.3;
      const maxOpacity = 1;
      const duration = 0.5 + Math.random() * 1.5; // 0.5 to 2 seconds
      const delay = Math.random() * 2; // Random delay up to 2 seconds

      gsap.to(star, {
        opacity: minOpacity + Math.random() * (maxOpacity - minOpacity),
        duration: duration,
        delay: delay,
        repeat: -1,
        yoyo: true,
        ease: 'power1.inOut'
      });
    });
  }

  /**
   * Initialize Christmas lights twinkling animation
   */
  function initChristmasLightsTwinkling(lightsGroup) {
    if (!lightsGroup) return;
    
    // Get all light elements (paths and ellipses) within the group
    const lightElements = lightsGroup.querySelectorAll('path, ellipse, circle');
    
    if (lightElements.length === 0) return;

    // Create twinkling animation for each light
    lightElements.forEach((light, index) => {
      // Random delay and duration for more natural effect
      const delay = Math.random() * 2.5; // Random delay up to 2.5 seconds
      const duration = 0.6 + Math.random() * 0.8; // 0.6 to 1.4 seconds
      
      // Twinkle animation - subtle brightness changes
      gsap.to(light, {
        opacity: 0.3 + Math.random() * 0.3, // Vary between 0.3 and 0.6
        duration: duration,
        delay: delay,
        repeat: -1,
        yoyo: true,
        ease: 'power1.inOut'
      });
    });
  }

  /**
   * Initialize dark windows toggle
   */
  function initDarkWindowsToggle(svg, darkWindows, chapterState, sectionType) {
    // Get message element (hotspot is hidden)
    const hotspot = svg.querySelector('#hotspot');
    const turnOnTheLights = svg.querySelector('#turn-on-the-lights');
    
    // Get all string light groups
    const stringLights = svg.querySelector('#string-lights');
    const lights = svg.querySelector('#lights');
    const lights1 = svg.querySelector('#lights1');
    const lights2 = svg.querySelector('#lights2');
    const lights3 = svg.querySelector('#lights3');
    const allLightGroups = [stringLights, lights, lights1, lights2, lights3].filter(Boolean);
    
    // Hide hotspot immediately
    if (hotspot) {
      hotspot.style.visibility = 'hidden';
      hotspot.style.display = 'none';
      hotspot.style.opacity = '0';
      hotspot.style.pointerEvents = 'none';
    }
    
    // Restore saved state
    let lightsOn = chapterState.lightsOn || false;
    
    // Set initial state based on saved state
    if (lightsOn) {
      gsap.set(darkWindows, { opacity: 0 });
      darkWindows.style.display = 'none';
      
      // Show string lights and start twinkling
      allLightGroups.forEach(lightGroup => {
        if (lightGroup) {
          gsap.set(lightGroup, { opacity: 1 });
          lightGroup.style.visibility = 'visible';
          initChristmasLightsTwinkling(lightGroup);
        }
      });
    } else {
      gsap.set(darkWindows, { opacity: 1 });
      darkWindows.style.display = 'block';
      
      // Keep lights hidden
      allLightGroups.forEach(lightGroup => {
        if (lightGroup) {
          gsap.set(lightGroup, { opacity: 0 });
          lightGroup.style.visibility = 'hidden';
        }
      });
    }
    
    // Make message clickable (hotspot is hidden)
    if (turnOnTheLights) {
      turnOnTheLights.style.cursor = 'pointer';
      turnOnTheLights.style.pointerEvents = 'auto';
      
      // // Add hover effect
      // turnOnTheLights.addEventListener('mouseenter', function() {
      //   gsap.to(turnOnTheLights, {
      //     scale: 1.1,
      //     duration: 0.2,
      //     ease: 'power2.out',
      //     transformOrigin: 'center center'
      //   });
      // });
      
      // turnOnTheLights.addEventListener('mouseleave', function() {
      //   gsap.to(turnOnTheLights, {
      //     scale: 1,
      //     duration: 0.2,
      //     ease: 'power2.out'
      //   });
      // });

      const introMessageHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Only turn lights on (not toggle)
        if (!lightsOn) {
          lightsOn = true;

          // Mark hotspot as complete
          if (Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
            Mcmn.CookieManager.markHotspotComplete(sectionType, 'hotspot');
            // Check completion after marking hotspot
            if (Mcmn.checkCompletion) {
              const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
              Mcmn.checkCompletion(viewedSections);
            }
          }

          // Save state
          chapterState.lightsOn = lightsOn;
          if (Mcmn.saveChapterState) {
            Mcmn.saveChapterState(sectionType, chapterState);
          }

          // Fade out dark windows
          gsap.to(darkWindows, {
            opacity: 0,
            duration: 0.8,
            ease: 'power2.out',
            onComplete: function() {
              darkWindows.style.display = 'none';
            }
          });
          
          // Fade in string lights and start twinkling
          allLightGroups.forEach(lightGroup => {
            if (lightGroup) {
              lightGroup.style.visibility = 'visible';
              gsap.to(lightGroup, {
                opacity: 1,
                duration: 0.8,
                ease: 'power2.out',
                onComplete: function() {
                  // Start twinkling animation after fade in
                  initChristmasLightsTwinkling(lightGroup);
                }
              });
            }
          });
          
          // Trigger audio start using stored reference
          if (window.McmnExperience && window.McmnExperience.introAudioStart && window.McmnExperience.introAudioStart[sectionType]) {
            window.McmnExperience.introAudioStart[sectionType]();
          }
        }
      };
      
      turnOnTheLights.addEventListener('click', introMessageHandler);
      turnOnTheLights.addEventListener('touchend', introMessageHandler, { passive: false });
    }
  }

  /**
   * Initialize mouse-based perspective transforms
   */
  function initMousePerspective(container, layers) {
    // Initialize layers with transform origin
    Object.keys(layers).forEach(layerKey => {
      const layer = layers[layerKey];
      if (layer) {
        gsap.set(layer, { x: 0, y: 0, transformOrigin: 'center center' });
      }
    });

    // Depth values for each layer
    const depths = {
      background: 0.5,
      midground: 0.4,
      foreground: 0.3,
      treeLayer: 0.3, // Same as foreground
      darkWindows: 0.3 // Same as foreground
    };

    // Throttle function for performance
    let ticking = false;
    let mouseX = 0;
    let mouseY = 0;

    function updateTransforms() {
      const rect = container.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      // Calculate distance from center (normalized to -1 to 1)
      const deltaX = (mouseX - centerX) / (rect.width / 2);
      const deltaY = (mouseY - centerY) / (rect.height / 2);

      // Apply transforms to each layer based on depth
      Object.keys(layers).forEach(layerKey => {
        const layer = layers[layerKey];
        if (!layer) return;

        const depth = depths[layerKey];
        const moveX = deltaX * depth * 30; // Max 30px movement
        const moveY = deltaY * depth * 30;

        gsap.to(layer, {
          x: moveX,
          y: moveY,
          duration: 1.2,
          ease: 'power1.out'
        });
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateTransforms);
        ticking = true;
      }
    }

    // Mouse move handler
    container.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      requestTick();
    });

    // Reset on mouse leave
    container.addEventListener('mouseleave', function() {
      const rect = container.getBoundingClientRect();
      mouseX = rect.left + rect.width / 2;
      mouseY = rect.top + rect.height / 2;
      requestTick();
    });
  }

  /**
   * Initialize Intro section
   */
  function initIntroSection(svgContainer, svg, activeSection, chapterState, sectionType) {
    // Get SVG elements
    const stars = svg.querySelector('#stars');
    const darkWindows = svg.querySelector('#dark-windows');
    const background = svg.querySelector('#background');
    const midground = svg.querySelector('#midground');
    const foreground = svg.querySelector('#foreground');
    const treeLayer = svg.querySelector('#tree-layer');
    const hotspot = svg.querySelector('#hotspot');

    if (!stars || !darkWindows || !background || !midground || !foreground || !treeLayer) {
      return;
    }
    // Initialize star blinking animation
    initStarBlinking(stars);

    // Initialize audio for intro section FIRST (so audio functions are available)
    initIntroAudio(svgContainer, svg, hotspot, chapterState, sectionType);

    // Initialize dark windows toggle with saved state (uses #hotspot from SVG)
    // This must come after audio init so it can access audio start function
    initDarkWindowsToggle(svg, darkWindows, chapterState, sectionType);

    // Mouse parallax effect disabled
    // Initialize mouse-based perspective transforms
    // Dark windows move with foreground (same depth)
    // initMousePerspective(svgContainer, {
    //   background: background,
    //   midground: midground,
    //   foreground: foreground,
    //   treeLayer: treeLayer,
    //   darkWindows: darkWindows
    // });

    // Register cleanup handler for when chapter is offloaded
    if (Mcmn.registerChapterInstance) {
      Mcmn.registerChapterInstance(sectionType, {
        cleanup: function() {
          // Stop audio for this chapter
          if (Mcmn.stopAudioForSection) {
            Mcmn.stopAudioForSection(sectionType);
          }

          // Get light groups to clean up their animations
          const stringLights = svg.querySelector('#string-lights');
          const lights = svg.querySelector('#lights');
          const lights1 = svg.querySelector('#lights1');
          const lights2 = svg.querySelector('#lights2');
          const lights3 = svg.querySelector('#lights3');
          const allLightGroups = [stringLights, lights, lights1, lights2, lights3].filter(Boolean);

          // Kill all GSAP animations
          gsap.killTweensOf(stars);
          gsap.killTweensOf(darkWindows);
          gsap.killTweensOf(background);
          gsap.killTweensOf(midground);
          gsap.killTweensOf(foreground);
          gsap.killTweensOf(treeLayer);
          gsap.killTweensOf(hotspot);
          gsap.killTweensOf(svg);
          gsap.killTweensOf(svgContainer);
          
          // Kill light animations
          allLightGroups.forEach(lightGroup => {
            if (lightGroup) {
              gsap.killTweensOf(lightGroup);
              // Also kill animations on individual light elements
              const lightElements = lightGroup.querySelectorAll('path, ellipse, circle');
              lightElements.forEach(light => gsap.killTweensOf(light));
            }
          });

          // Clean up all SVG content - remove children to free memory
          while (svg && svg.firstChild) {
            svg.removeChild(svg.firstChild);
          }

          // Mark SVG as unloaded AND remove it from container so it reloads on next visit
          if (svgContainer) {
            svgContainer.setAttribute('data-svg-loaded', 'false');
            // Also remove the SVG element itself so it gets reloaded fresh
            const svgElement = svgContainer.querySelector('svg');
            if (svgElement && svgElement.parentNode) {
              svgElement.parentNode.removeChild(svgElement);
            }
          }
        }
      });
    }
  }

  /**
   * Initialize audio for intro section
   */
  function initIntroAudio(svgContainer, svg, hotspot, chapterState, sectionType) {
    // Initialize audio
    let audio = null;
    let isPlaying = false;
    let isMuted = false;
    let hotspotActivated = false; // Track if hotspot has been clicked
    
    // Get base path for files
    let basePath = '';
    if (typeof Drupal !== 'undefined' && Drupal.settings && Drupal.settings.basePath) {
      basePath = Drupal.settings.basePath;
    } else {
      const pathParts = window.location.pathname.split('/');
      const filtered = pathParts.filter(p => p);
      if (filtered.length > 0) {
        filtered.pop();
      }
      basePath = filtered.length > 0 ? '/' + filtered.join('/') : '';
    }
    basePath = basePath.replace(/\/$/, '');
    
    const audioPath = basePath + '/themes/custom/discoverpr_v2_theme/audio/mcmn-experience/intro.mp4';
    
    // Get audio control buttons from template
    const section = svgContainer.closest('.mcmn-section');
    const playButton = section ? section.querySelector('[data-mcmn-audio="play"]') : null;
    const pauseButton = section ? section.querySelector('[data-mcmn-audio="pause"]') : null;
    const muteButton = section ? section.querySelector('[data-mcmn-audio="mute"]') : null;
    
    // Show play button, hide pause button
    function showPlayButton() {
      if (playButton) {
        playButton.style.display = 'flex';
      }
      if (pauseButton) {
        pauseButton.style.display = 'none';
      }
    }
    
    // Show pause button, hide play button
    function showPauseButton() {
      if (pauseButton) {
        pauseButton.style.display = 'flex';
      }
      if (playButton) {
        playButton.style.display = 'none';
      }
    }
    
    // Show audio controls after first interaction
    function showAudioControls() {
      if (muteButton) {
        muteButton.style.display = 'flex';
      }
    }
    
    // Initialize: Show play button, hide pause and mute buttons initially
    showPlayButton();
    if (muteButton) {
      muteButton.style.display = 'none';
    }
    
    // Start audio
    function startAudio() {
      // Prevent multiple audio instances
      if (!audio) {
        audio = new Audio(audioPath);
        audio.loop = true;
        
        // Register this audio instance
        if (Mcmn.registerAudio) {
          Mcmn.registerAudio(sectionType, audio);
        }
        
        // Ensure looping works even if browser doesn't support loop attribute
        audio.addEventListener('ended', function() {
          if (isPlaying) {
            audio.currentTime = 0;
            audio.play().catch(error => {
              // Audio restart failed
            });
          }
        });
        
        audio.addEventListener('play', function() {
          isPlaying = true;
          showPauseButton();
          showAudioControls();
          // Note: Don't disable intro hotspot as it controls lights
        });
        
        audio.addEventListener('pause', function() {
          isPlaying = false;
          showPlayButton();
          // Note: Intro hotspot stays enabled for lights functionality
        });
      }
      
      // Only play if not already playing
      if (!isPlaying && audio) {
        audio.play().then(() => {
          // Ensure buttons are shown even if play event hasn't fired yet
          showPauseButton();
          showAudioControls();
        }).catch(error => {
          // Audio play failed
        });
      }
    }
    
    // Pause audio
    function pauseAudio() {
      if (audio && isPlaying) {
        audio.pause();
      }
    }
    
    // Toggle mute
    function toggleMute() {
      if (!audio) return;
      
      isMuted = !isMuted;
      audio.muted = isMuted;
      
      // Update mute button visual state
      if (muteButton) {
        if (isMuted) {
          muteButton.classList.add('muted');
        } else {
          muteButton.classList.remove('muted');
        }
      }
    }
    
    // Wire up play button (mobile touch support)
    if (playButton) {
      const playHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        startAudio();
      };
      playButton.addEventListener('click', playHandler);
      playButton.addEventListener('touchend', playHandler, { passive: false });
    }
    
    // Wire up pause button (mobile touch support)
    if (pauseButton) {
      const pauseHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        pauseAudio();
      };
      pauseButton.addEventListener('click', pauseHandler);
      pauseButton.addEventListener('touchend', pauseHandler, { passive: false });
    }
    
    // Wire up mute button (mobile touch support)
    if (muteButton) {
      const muteHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMute();
      };
      muteButton.addEventListener('click', muteHandler);
      muteButton.addEventListener('touchend', muteHandler, { passive: false });
    }
    
    // Store audio start function reference for message handler
    window.McmnExperience = window.McmnExperience || {};
    if (!window.McmnExperience.introAudioStart) {
      window.McmnExperience.introAudioStart = {};
    }
    window.McmnExperience.introAudioStart[sectionType] = function() {
      // Start audio when lights are turned on
      if (!hotspotActivated) {
        hotspotActivated = true;
        startAudio();
      } else if (!isPlaying && audio) {
        startAudio();
      }
    };
    
    // Note: Audio does NOT auto-start - waits for user to click message (turn on lights)
    
    // Register cleanup handler for when chapter is offloaded
    if (Mcmn.registerChapterInstance) {
      Mcmn.registerChapterInstance(sectionType, {
        cleanup: function() {
          // Stop audio for this chapter
          if (Mcmn.stopAudioForSection) {
            Mcmn.stopAudioForSection(sectionType);
          }

          // Get light groups to clean up their animations
          const stringLights = svg.querySelector('#string-lights');
          const lights = svg.querySelector('#lights');
          const lights1 = svg.querySelector('#lights1');
          const lights2 = svg.querySelector('#lights2');
          const lights3 = svg.querySelector('#lights3');
          const allLightGroups = [stringLights, lights, lights1, lights2, lights3].filter(Boolean);

          // Kill all GSAP animations
          gsap.killTweensOf(stars);
          gsap.killTweensOf(darkWindows);
          gsap.killTweensOf(background);
          gsap.killTweensOf(midground);
          gsap.killTweensOf(foreground);
          gsap.killTweensOf(treeLayer);
          gsap.killTweensOf(hotspot);
          gsap.killTweensOf(svg);
          gsap.killTweensOf(svgContainer);
          
          // Kill light animations
          allLightGroups.forEach(lightGroup => {
            if (lightGroup) {
              gsap.killTweensOf(lightGroup);
              // Also kill animations on individual light elements
              const lightElements = lightGroup.querySelectorAll('path, ellipse, circle');
              lightElements.forEach(light => gsap.killTweensOf(light));
            }
          });

          // Clean up all SVG content - remove children to free memory
          while (svg && svg.firstChild) {
            svg.removeChild(svg.firstChild);
          }

          // Mark SVG as unloaded AND remove it from container so it reloads on next visit
          if (svgContainer) {
            svgContainer.setAttribute('data-svg-loaded', 'false');
            // Also remove the SVG element itself so it gets reloaded fresh
            const svgElement = svgContainer.querySelector('svg');
            if (svgElement && svgElement.parentNode) {
              svgElement.parentNode.removeChild(svgElement);
            }
          }
        }
      });
    }
  }

  // Export functions to shared namespace
  Mcmn.initStarBlinking = initStarBlinking;
  Mcmn.initChristmasLightsTwinkling = initChristmasLightsTwinkling;
  Mcmn.initDarkWindowsToggle = initDarkWindowsToggle;
  Mcmn.initMousePerspective = initMousePerspective;
  Mcmn.initIntroSection = initIntroSection;

})(Drupal, once);

